import { FormikProvider, useFormik } from "formik";
import { Form } from "react-router-dom";
import * as Yup from "yup";
import InputFormik from "../../../../common/components/form/InputFormik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { isCPF } from "../../../../common/helpers/is-cpf";
import { maskCPF } from "../../../../common/helpers/mask.helpers";
import isValidEmail from "@/common/helpers/is-email";


const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Nome do indicador é obrigatório')
    .test(
      'full-name',
      'Deve incluir pelo menos um nome e um sobrenome',
      value => {
        if (!value) {
          return false;
        }

        const names = value.split(' ');
        return names.length >= 2;
      }
    ),
  cpf: Yup.string()
    .required('CPF é obrigatório')
    .test('valida-cpf', 'CPF inválido', value => isCPF(value)),
  email: Yup.string()
    .required("Email é obrigatório")
    .test("valida-email", "email inválido", value => isValidEmail(value))
});

type FormPropsCreateIndicator = {
  onSubmit: (values: { name: string }) => void;
}

export default function FormCreateIndicator(props: FormPropsCreateIndicator) {
  const initialValues = { name: '' };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: handleSubmit,
    validationSchema: validationSchema
  })

  return (
    <FormikProvider value={formik}>
      <Form>
        <InputFormik
          label="Nome/Razão Social completo do indicador:"
          name="name"
          className="w-full"
          required={true}
        />

        <InputFormik
          label="Informe o CPF:"
          name="cpf" // Certifique-se de que o nome do campo esteja consistente
          mask={maskCPF}
        />

        <InputFormik
          label="Informe o email:"
          name="email" // Certifique-se de que o nome do campo esteja consistente
        />

        {/* Botão de Envio */}
        <div className="flex justify-end">
          <ButtonWithLoader disabled={Object.keys(formik.errors).length > 0} onClick={formik.handleSubmit}> Enviar </ButtonWithLoader>
        </div>
      </Form>
    </FormikProvider>
  );
}


